import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { withAppLayout } from '../core/routes';
import ProductsPage from './pages/ProductsPage';
import ProductFormPage from './pages/ProductFormPage';
import ProductViewPage from './pages/ProductViewPage';
import ProductTypesSettingsPage from './pages/ProductTypesSettingsPage';

const ProductIdToEditRedirect = () => {
  const { id } = useParams();
  return <Navigate to={`/products/${encodeURIComponent(id)}/edit`} replace />;
};

export const productsRoutes = [
  { path: '/products', element: withAppLayout(<ProductsPage />) },
  { path: '/products/types', element: withAppLayout(<ProductTypesSettingsPage />) },
  { path: '/products/new', element: withAppLayout(<ProductFormPage />) },
  { path: '/products/:id/edit', element: withAppLayout(<ProductFormPage />) },
  { path: '/products/:id/view', element: withAppLayout(<ProductViewPage />) },
  { path: '/products/:id', element: withAppLayout(<ProductIdToEditRedirect />) },
  { path: '/settings/product-types', element: <Navigate to="/products/types" replace /> },
];
